// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"172":"c1f46c22ee7eda84eb30","895":"b1a94db04f164f5e3538"}[chunkId] + ".css";
};